/**
 * @returns {HeadersInit}
 */
export function getMiddlewareHeaders() {
  return {
    'Content-Type': 'application/json',
  }
}
